<template>
  <div class="mt-20">
    <div class="container max-w-screen-md">
      <wavy-card>
        <div class="-mb-36">
          <div class="absolute left-0 right-0 top-0 flex justify-center">
            <font-awesome-layers v-if="!onWaitlist" class="-mt-8 text-6xl">
              <font-awesome-icon :icon="['fas', 'circle']" class="text-green-400" />
              <font-awesome-icon :icon="['fas', 'layer-group']" class="text-green-800 text-3xl" />
            </font-awesome-layers>
            <font-awesome-layers v-else class="-mt-8 text-6xl">
              <font-awesome-icon :icon="['fas', 'circle']" class="text-green-400" />
              <font-awesome-icon :icon="['fas', 'check']" class="text-green-800 text-3xl" />
            </font-awesome-layers>
          </div>
          <div v-if="!onWaitlist" class="mt-6 text-center">
            <p class="font-bold text-center text-brand-black text-2xl">Join the waitlist</p>
            <p class="font-semibold text-brand-brown text-center text-lg mt-1">
              Send us a message so that we can add you to the waitlist for our {{ feature }} for
              <span class="capitalize text-brand-black font-semibold">{{ provider }}</span
              >.
            </p>
            <div class="mt-8">
              <el-button @click="joinWaitlist" v-loading="loading" type="primary" class="text-lg font-semibold py-4" id="dunning-waitlist-cta"
                >Join the Waitlist →</el-button
              >
            </div>
          </div>
          <div v-else class="mt-6 text-center">
            <p class="font-bold text-center text-brand-black text-2xl">You're on the waitlist</p>
            <p class="font-semibold text-brand-brown text-center text-lg mt-1">
              We'll send you an email as soon as our {{ feature }} is ready for
              <span class="capitalize text-brand-black font-semibold">{{ provider }}</span
              >.
            </p>
            <div class="mt-8">
              <el-button @click="openChat" type="primary" class="text-lg font-semibold py-4" id="dunning-waitlist-question"
                >Ask A Question →</el-button
              >
            </div>
          </div>
        </div>
      </wavy-card>
    </div>
  </div>
</template>

<script>
import WavyCard from '@/components/UI/WavyCard.vue';
import { mapGetters } from 'vuex';
import eventBus from '@/helpers/event-bus';

export default {
  name: 'WaitlistCard',
  components: {
    WavyCard,
  },
  props: {
    feature: {
      type: String,
      required: true,
    },
    onWaitlist: {
      type: Boolean,
      required: true,
    },
    signupAction: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['provider']),
  },
  methods: {
    openChat() {
      eventBus.$emit('openChat');
    },
    async joinWaitlist() {
      this.loading = true;
      try {
        await this.$store.dispatch(this.signupAction);
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
